import React from 'react';
import './style.css';
import { Fragment, useEffect, useState } from 'react';
import SmartControlTags from './SmartControlTags';
import SmartMotorControl from './SmartMotorControl';
import SmartLightControl from './SmartLightingControl';

const SmartControl = (props) => {
  const [formType, setFormType] = useState('');

  useEffect(() => {
    if (props.match.params.formName) {
      setFormType(props.match.params.formName);
    }
    document.title = 'Rubus-Smart Control Form';
  }, [props.match.params.formName]);

  return (
    <Fragment>
      {formType === 'VibrationDashboard' && <SmartMotorControl />}
      {formType === 'SmartLightControl' && <SmartLightControl />}
      {formType === 'SmartControlTag' && <SmartControlTags />}
    </Fragment>
  );
};

export default SmartControl;
